"use client";

import {useCallback} from "react";
import {useAppDispatch, useAppSelector} from "@/redux/hooks";
import {setProductsParamsRaw} from "@/redux/products.slice";
import {changeUrl} from "@/lib/url/query-string";

export function useProductsFilters() {
    const dispatch = useAppDispatch();
    const productsParams = useAppSelector((state) => state.products);

    const updateFilters = useCallback((newParams) => {
        const currentParams = productsParams;
        const changedFilter = Object.keys(newParams).some((key) =>
            key !== "Page" &&
            JSON.stringify(currentParams[key]) !== JSON.stringify(newParams[key])
        );
        const nextParams = {
            ...currentParams,
            ...newParams,
            Page: changedFilter ? 1 : (newParams.Page ?? currentParams.Page ?? 1),
        };

        for (const key of ["OnlyNewests", "OnlyOffers", "OnlyWithPicture"]) {
            if (nextParams[key] === false) nextParams[key] = undefined;
        }

        dispatch(setProductsParamsRaw(nextParams));
        changeUrl(nextParams);
    }, [dispatch, productsParams]);

    return {
        updateFilters,
        productsParams
    };
}
